import { useQuery } from 'react-query';
import qs from 'qs';

import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 10,
  search: '',
  queryKey: ['direct-supplier-files'],
  queryOptions: {},
};

const getDirectSupplierFiles = async (directID, tcID, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });
  const {
    data: { data, total },
  } = await axios.get(`/api/directs/${directID}/suppliers/${tcID}/files?${queryString}`);

  return { files: data || [], total };
};

export const useDirectSupplierFiles = (directID, tcID, queryParams = {}) => {
  const { queryKey, queryOptions, limit, page, ...rest } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    page,
    offset: page * limit,
    ...rest,
  };

  return useQuery([...queryKey, tcID], () => getDirectSupplierFiles(directID, tcID, queryStringParams), {
    initialData: { files: [], total: 0 },
    ...queryOptions,
  });
};